const googleAnalyticEvents = {

    setPageViewEvent: ({page_title}) => {
        return {
            eventName: 'page_view',
            attributes: {
                page_title: page_title
            }
        }
    }
}

export default googleAnalyticEvents;